export const RADIUS_BUTTON_ORDER = 30
export const RADIUS_CIRCLE_ITEM = 25
export const RADIUS_MODAL = '15px'
export const BACKGROUND_COLOR_ITEMS = "rgba(255, 255, 255, 0.09)"
export const BACKGROUND_COLOR_MINUS_PLUS = "rgba(255, 255, 255, 0.26)"